import { render, staticRenderFns } from "./useStatistics.vue?vue&type=template&id=16fbff2b&scoped=true"
import script from "./useStatistics.vue?vue&type=script&lang=js"
export * from "./useStatistics.vue?vue&type=script&lang=js"
import style0 from "./useStatistics.vue?vue&type=style&index=0&id=16fbff2b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fbff2b",
  null
  
)

export default component.exports